import React from 'react'
import { MdArrowCircleUp } from 'react-icons/md'

const Details = () => { 
  return (
    <div className='bg-green-700 text-white p-[2em] w-[85%] ml-[7.5%] rounded-md font-[Lexend]'>
        <p className='lg:text-xl text-extrabold text-center'>Who we are</p>
        <p className='lg:text-base text-[rgba(255,255,255,1)] text-center capitalize font-extralight mb-[3em]'>We are a fast growing rent management agency</p>

        <div className="grid  lg:grid-cols-2 lg:grid-rows-2 gap-y-[2em] lg:pl-[5em]">

          <div className="flex flex-col p-[1em] rounded-md px-[1em] h-[12em] w-[17em] lg:w-[25em] gap-[1em] bg-[rgba(255,255,255,0.16)]">
             <MdArrowCircleUp className='text-xl'/>
               <p>Branding & Design</p>
            <p className='text-sm'>From personal and corporate branding to elegant graphic and motion design, we craft an identity that resonates and endures.</p>

          </div>
          
          <div className="flex flex-col p-[1em] lg:-ml-[2em] rounded-md h-[12em] px-[1em] w-[17em] lg:w-[25em] gap-[1em] bg-[rgba(255,255,255,0.16)]">
            <MdArrowCircleUp className='text-xl'/>
            <p  className='text-sm'>Digital Marketing</p>
            <p  className='text-sm' >We go beyond likes and shares. Our strategies in social media management, content marketing, and SEO/SEM are designed to attract, engage, and convert your ideal customers.</p>
          </div>
        
          <div className="flex flex-col p-[1em] lg:mb-[3.5em] lg:-mt-[1em] rounded-md px-[1em] ] w-[17em] lg:w-[25em] gap-[1em] bg-[rgba(255,255,255,0.16)]">
             <MdArrowCircleUp className='text-xl'/>
            <p >Media Production</p>
            <p  className='text-sm' >Our in-house media team captures your story with professional photography, videography, and podcast production that captivates your audience.</p>
          </div>
          
          <div className="flex flex-col p-[1em] lg:-mt-[1em] lg:-ml-[2em] lg:mb-[3.5em] rounded-md px-[1em] ] w-[17em] lg:w-[25em]  gap-[1em] bg-[rgba(255,255,255,0.16)]">
           <MdArrowCircleUp className='text-xl'/>
            <p>Web & App Development</p>
            <p  className='text-sm' >Your digital foundation is your most valuable asset. We build stunning, high-performing websites and mobile applications that deliver exceptional user experiences, converting curious visitors to paying customers. </p>
          </div>

        </div>
        
    </div>
  )
 }
export default Details;
